var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.75C15.7799 13.7506 15.0887 14.0337 14.575 14.5384L7.33332 11.3117V11V10.6975L14.575 7.4617C15.0286 7.9063 15.6221 8.18019 16.2547 8.23684C16.8873 8.2935 17.52 8.12943 18.0454 7.77251C18.5707 7.41559 18.9564 6.88781 19.1367 6.27882C19.3171 5.66984 19.2812 5.01718 19.0349 4.43171C18.7887 3.84624 18.3474 3.36404 17.786 3.06703C17.2246 2.77001 16.5777 2.67648 15.9551 2.80233C15.3326 2.92817 14.7728 3.26563 14.3708 3.75739C13.9688 4.24915 13.7495 4.86489 13.75 5.50003V5.8117L6.50832 9.03837C6.12182 8.65864 5.63175 8.40155 5.09965 8.29937C4.56754 8.1972 4.01711 8.25448 3.51745 8.46404C3.01779 8.6736 2.59117 9.0261 2.29114 9.47728C1.99111 9.92845 1.83105 10.4582 1.83105 11C1.83105 11.5419 1.99111 12.0716 2.29114 12.5228C2.59117 12.974 3.01779 13.3265 3.51745 13.536C4.01711 13.7456 4.56754 13.8029 5.09965 13.7007C5.63175 13.5985 6.12182 13.3414 6.50832 12.9617L13.75 16.1975V16.5C13.75 17.0439 13.9113 17.5756 14.2134 18.0279C14.5156 18.4801 14.9451 18.8326 15.4476 19.0407C15.9501 19.2488 16.503 19.3033 17.0365 19.1972C17.5699 19.0911 18.0599 18.8292 18.4445 18.4446C18.8291 18.06 19.091 17.57 19.1971 17.0365C19.3033 16.5031 19.2488 15.9502 19.0407 15.4477C18.8325 14.9452 18.48 14.5157 18.0278 14.2135C17.5756 13.9113 17.0439 13.75 16.5 13.75Z",
    fill: "#FF7B29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.55c2e4a968e2b926e8bcacbbd17c324a.svg";
export { ForwardRef as ReactComponent };